import {GET_SPONSOR_OPTIONS} from '../../actionTypes';

const sponsorOptions = (state = [], action) => {
	switch(action.type) {
		case GET_SPONSOR_OPTIONS:
			return [...action.payload];
		default:
			return state;
	}
}

export default sponsorOptions;